import * as types from "./actionTypes";
import { showModalSuccess, hideModalSuccess } from "./modalActions";
import { showAlertSuccess } from "./alertActions";
import expenseService from "../services/expenseService";

export function loadExpenseSuccess(expenses) {
  return {
    type: types.LOAD_EXPENSE_SUCCESS,
    expenses
  };
}

export function getExpenseSuccess(expense) {
  return { type: types.GET_EXPENSE_SUCCESS, expense };
}

export function loadingExpense(status = true) {
  return {
    type: types.LOADING_EXPENSE,
    loadingExpense: status
  };
}

export function savingExpense(status = true) {
  return { type: types.SAVING_EXPENSE, savingExpense: status };
}

export function createExpenseSuccess(expense) {
  return { type: types.CREATE_EXPENSE_SUCCESS, expense };
}

export function updateExpenseSuccess(expense) {
  return { type: types.UPDATE_EXPENSE_SUCCESS, expense };
}

export function deleteExpenseSuccess(expenseId) {
  return { type: types.DELETE_EXPENSE_SUCCESS, expenseId };
}

export function requestExpenseId(expenseId) {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_EXPENSE_ID,
      expenseToDelete: expenseId
    });
    dispatch(showModalSuccess("expenseDeleteModal"));
  };
}

export function loadExpenses(query) {
  return (dispatch) =>
    expenseService
      .loadExpenses(query)
      .then((data) => dispatch(loadExpenseSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function loadExpensesByCustomerId(id) {
  return (dispatch) =>
    expenseService
      .loadExpensesByCustomerId(id)
      .then((data) => dispatch(loadExpenseSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function loadExpensesByEmployeeId(id) {
  return (dispatch) =>
    expenseService
      .loadExpensesByEmployeeId(id)
      .then((data) => dispatch(loadExpenseSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function loadExpensesByFilters(body) {
  return (dispatch) =>
    expenseService
      .loadExpensesByFilters(body)
      .then((data) => {
        dispatch(loadExpenseSuccess(data));

        return data;
      })
      .catch((error) =>
        dispatch(showAlertSuccess("Unable to load expenses.", error))
      );
}

export function getExpense(id, showEXPENSEDetails = false) {
  return (dispatch) =>
    expenseService
      .getExpense(id)
      .then((expense) => {
        dispatch(getExpenseSuccess(expense));
        if (showEXPENSEDetails) {
          dispatch(showModalSuccess("expenseDetailsModal"));
        }
      })
      .catch((error) => {
        dispatch(showAlertSuccess(error.description, "error"));
      });
}

export function createExpense(expense) {
  return (dispatch) => {
    dispatch(savingExpense());
    return expenseService
      .createExpense(expense)
      .then((createdExpense) => {
        dispatch(createExpenseSuccess(createdExpense));
        dispatch(hideModalSuccess("expenseDetailsModal"));
        dispatch(savingExpense(false));
        dispatch(showAlertSuccess("Expense created successfully", "success"));
        // dispatch(push('/app/expenses'));
      })
      .catch((error) => {
        dispatch(savingExpense(false));
        dispatch(showAlertSuccess(error, "error"));
      });
  };
}

export function updateExpense(expense) {
  return (dispatch) => {
    dispatch(savingExpense());
    return expenseService
      .updateExpense(expense)
      .then(() => {
        // dispatch(updateExpenseSuccess(updatedExpense));
        dispatch(hideModalSuccess("expenseDetailsModal"));
        dispatch(savingExpense(false));
        dispatch(showAlertSuccess("Expense updated successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingExpense(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function deleteExpense(id) {
  return (dispatch) =>
    expenseService
      .deleteExpense(id)
      .then(() => {
        dispatch(deleteExpenseSuccess(id));
        dispatch(showAlertSuccess("Expense deleted successfully", "success"));
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function uploadFile(files) {
  return (dispatch) => {
    dispatch(savingExpense());
    if (files.length === 1) {
      return expenseService
        .uploadFile(files[0])
        .then((res) => {
          dispatch(savingExpense(false));
          return res.data;
        })
        .catch((error) => {
          dispatch(savingExpense(false));
          dispatch(showAlertSuccess(error.description, "error"));
        });
    }
    dispatch(savingExpense(false));
    dispatch(showAlertSuccess("Upload 1 File at a Time", "error"));
  };
}

export function downloadFile(expense, file) {
  return (dispatch) =>
    expenseService
      .downloadFile(expense, file)
      .then(() => {
        dispatch(
          showAlertSuccess("Attachment downloaded successfully", "success")
        );
      })
      .catch((error) => {
        dispatch(showAlertSuccess(error.description, "error"));
      });
}

export function requestExpenseReceiptId(expenseReceiptId) {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_EXPENSE_RECEIPT_ID,
      expenseReceiptToDelete: expenseReceiptId
    });
    dispatch(showModalSuccess("expenseReceiptDeleteModal"));
  };
}

export function updateAttachment(expense, file) {
  return (dispatch) => {
    dispatch(savingExpense());
    return expenseService
      .updateLocation(expense, file)
      .then((updatedExpense) => {
        dispatch(updateExpenseSuccess(updatedExpense));
        dispatch(savingExpense(false));
        dispatch(
          showAlertSuccess("Attachment updated successfully", "success")
        );
      })
      .catch((error) => {
        dispatch(savingExpense(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function deleteReceipt(expense, file) {
  return (dispatch) => {
    dispatch(savingExpense());
    return expenseService
      .deleteReceipt(expense, file)
      .then((updatedExpense) => {
        dispatch(updateExpenseSuccess(updatedExpense));
        dispatch(savingExpense(false));
        dispatch(showAlertSuccess("Receipt deleted successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingExpense(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function updateManyExpenses(expenses) {
  return (dispatch) => {
    dispatch(savingExpense());
    return expenseService
      .updateManyExpenses(expenses)
      .then(() => {
        dispatch(savingExpense(false));
        dispatch(showAlertSuccess("Expenses updated successfully", "success"));
      })
      .catch((error) => {
        dispatch(savingExpense(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}
